export default [
    {
        path: '/internal-help-text',
        props: true,
        component: () => import('@/views/InternalHelpText'),
    },
];